import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { v4 as uuidv4 } from 'uuid';
import { getFormatterTime } from "../../base/i18n";
import { getLocalUserUUID } from "../../base/localuser";
import { removeDocumentFile, setDocumentSharedFile } from "../actions";
import { DEFAULT_DOCUMENT } from "../constants";

const document_data = {
    uuid: null, 
    file: { name: null },
    isWhiteBoard: false,
    shared: false,
    page: null,
    list: null, 
    count: 1,
    complete: false,
    user_uuid: null
};

export default function AddDocumentButton({
    t, isWhiteBoard
}) {
    const dispatch = useDispatch();
    const user_uuid = useSelector(state => getLocalUserUUID(state));
    const addWhiteBoard = e => {
        e.preventDefault();
        const uuid = uuidv4();
        const time = `${getFormatterTime(new Date())}`;

        document_data.uuid = `${DEFAULT_DOCUMENT}_${uuid}`;
        document_data.file.name = time;
        document_data.isWhiteBoard = isWhiteBoard;
        document_data.page = null;
        document_data.user_uuid = user_uuid;

        dispatch(setDocumentSharedFile(document_data));
    };

    const addDocument = async e => {
        try {
            const file = e.target.files[0];
            
            if (!file) return;
            const extArr = file.name.split("\.");
            const ext = extArr[extArr.length - 1];
            
            if (ext.toUpperCase().indexOf("HWP") !== -1) {
                if (!window.confirm("한글 문서(HWP) 등록시 일부 표와 내용이 다를 수 있습니다.\n변환된 문서가 이상한 경우 한글 파일을 PDF파일로 변환 후 등록해 주세요.")) {
                    e.target.value = '';
                    return;
                }
            }


            const uuid = uuidv4();
            document_data.uuid = uuid;
            document_data.file.name = file.name;
            document_data.isWhiteBoard = isWhiteBoard;
            document_data.page = null;
            document_data.user_uuid = user_uuid;

            dispatch(setDocumentSharedFile(document_data, null, true));
            
            // 문서 변환 요청 
            const { complete, message } = await APP.API.convertShareDocument(file);
            if (!complete) {
                alert(t(message));
                dispatch(removeDocumentFile(uuid, isWhiteBoard));
            } else {
                document_data.uuid = message.uuid;

                dispatch(setDocumentSharedFile(document_data, uuid));
            }
            
            e.target.value = '';
        } catch (err) {
            e.target.value = '';
            console.log(err)
        }

    }

    return (
        <div className="add_btn noClick">
            { !isWhiteBoard ? 
                <input type="file" id="add_document" onChange={addDocument} /> : 
                <input type="button" id="add_document" onClick={addWhiteBoard} /> }
            <label htmlFor="add_document">
                <div>
                    <dd className="icoImg"></dd>
                    <dt> { isWhiteBoard ? t("document.addWhiteBoard") : t("document.addDocument")} </dt>
                </div>
            </label>
        </div>
    )
}

// function AddWhiteBoard({
//     t, dispatch
// }) {
//     const addBoard = () => {
//         const uuid = uuidv4();
//         const document = {
//             uuid: `${DEFAULT_DOCUMENT}_${uuid}`,
//             file: {
//                 name: `${new Date().toTimeString().replace(/.*(\d{2}:\d{2}:\d{2}).*/, "$1")}`
//             },
//             isConvert: true,
//             isWhiteBoard: true,
//             canvasList: new Map(),
//             page: new Array(),
//             shared: false
//         }

//         dispatch(setDocumentFile(document));
//     };

//     return (
//         <>
//             <div className="add_btn" onClick={addBoard}>
//                 <label htmlFor="add_document">
//                     <div>
//                         <dd className="icoImg"></dd>
//                         <dt className="noClick">{t("document.addWhiteBoard")}</dt>
//                     </div>
//                 </label>
//             </div>
//         </>
//     )
// }

// function AddDocument({
//     t, dispatch
// }) {
//     const addDocument = async e => {
//         const { files } = e.target;

//         for (let i =0; i < files.length; i++) {
//             const file = files[i];

//             try {
//                 // 문서 변환 요청 
//                 const { complete, message } = await APP.API.convertShareDocument(file);
//                 if (!complete) {
//                     alert(t(message));
//                     dispatch(removeDocumentFile(uuid));
//                     return;
//                 }

//                 if (message.uuid) {
//                     let data = {
//                         uuid: message.uuid,
//                         file: {name: file.name},
//                         isWhiteBoard: false,
//                         canvasList: new Array(),
//                         page: null,
//                         shared: false
//                     };
        
//                     dispatch(setDocumentFile(data));
//                     dispatch(setDocumentFile(data));
//                 }
//                 e.target.value = null;
//             } catch (err) {
//                 console.log(err)
//             }
            
//         };
//     };

//     return (
//         <>
//             <div className="add_btn">
//                 <input type="file" id="add_document" onChange={addDocument} />
//                 <label htmlFor="add_document">
//                     <div>
//                         <dd className="icoImg"></dd>
//                         <dt> {t("document.addDocument")} </dt>
//                     </div>
//                 </label>
//             </div>
//         </>
//     )
// }